import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/discount-calculator',
  component: () => import('../../routes/DiscountCalculator.svelte'),
  card: {
    id: 'discount-calculator',
    title: 'Discount Calculator',
    description: 'Calculate the final price after a discount and see how compound discounts stack up to save you more.',
    icon: 'percent',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/discount-calculator',
    category: 'Life & Budget',
  },
  seo: {
    title: 'Discount Calculator – Find Final Price After Discount',
    description: 'Free discount calculator to find the final price after a discount. Calculate savings on any purchase, see how compound (stacked) discounts compare, and understand the true cost of sales and promotions.',
  },
};

export default meta;
